const single = state => state.single
const singleStatic = state => state.singleStatic
const singleNews = state => state.singleNews
const singleAPI = state => state.singleAPI

export { single, singleStatic, singleNews, singleAPI }
